import { MapData } from "./types/MapData";

export const sampleMaps: MapData[] = ([
    {
        id: "sample-1",
        firstName: "דוגמה",
        familyName: "אחת",
        motherName: "שרה",
        birthDate: "1990-01-01",
        birth_time: "00:00",
        birth_lat: 32.0853,
        birth_lon: 34.7818,
        timezone: "Asia/Jerusalem",
        inner_sign_number: 1,
        surrounding_sign_number: 5,
        tur_value: 'A',
        profile_number: 4,
        created_at: new Date().toISOString(),
        user_id: "system",
    },
    {
        id: "sample-2",
        firstName: "דוגמה",
        familyName: "שנייה",
        motherName: "רבקה",
        birthDate: "1985-05-15",
        birth_time: "08:30",
        birth_lat: 31.7683,
        birth_lon: 35.2137,
        timezone: "Asia/Jerusalem",
        inner_sign_number: 8,
        surrounding_sign_number: 2,
        tur_value: 'B',
        profile_number: 1,
        created_at: new Date().toISOString(),
        user_id: "system",
    },
    {
        id: "sample-3",
        firstName: "דוגמה",
        familyName: "שלישית",
        motherName: "לאה",
        birthDate: "1992-11-22",
        birth_time: "22:15",
        birth_lat: 32.794,
        birth_lon: 34.9896,
        timezone: "Asia/Jerusalem",
        inner_sign_number: 4,
        surrounding_sign_number: 12,
        tur_value: 'C',
        profile_number: 6,
        created_at: new Date().toISOString(),
        user_id: "system",
    }
]) as MapData[];
